import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaGithub, FaGlobe, FaYoutube } from "react-icons/fa";
import {projects} from "../data/data";
import "./Projects.css"; // import custom css file

const Projects = () => {
  return (
    <div id="projects" className="py-5">
      <Container>
        <h2 className="text-center mb-5 py-3" style={{backgroundColor: "#283142", color: "white"}}>My Projects</h2>
        <Row>
          {projects.map((project) => (
            <Col md={4} key={project.name} className="mb-4">
              <div className="card h-100">
                <div className="project-image">
                  {project.image ? (
                    <img src={project.image} alt={project.name} />
                  ) : (
                    <div className="no-image"></div>
                  )}
                </div>
                <div className="card-body">
                  <h5 className="card-title">{project.name}</h5>
                  <p className="card-text">{project.desc}</p>
                  <ul className="list-inline">
                    {project.technologies.map((tech, index) => (
                      <li className="list-inline-item" key={index}>
                        <span className="badge badge-pill badge-secondary">{tech}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="project-buttons">
                    {project.links.github && (
                      <a href={project.links.github} className="btn btn-outline-primary mr-3 mb-3" target="_blank" rel="noreferrer">
                        <FaGithub className="mr-2" />
                        Github
                      </a>
                    )}
                    {project.links.live && (
                      <a href={project.links.live} className="btn btn-outline-success mr-3 mb-3" target="_blank" rel="noreferrer">
                        <FaGlobe className="mr-2" />
                        Live
                      </a>
                    )}
                    {project.links.youtube && (
                      <a href={project.links.youtube} className="btn btn-outline-danger mr-3 mb-3" target="_blank" rel="noreferrer">
                        <FaYoutube className="mr-2" />
                        Youtube
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Projects;